module.exports = __webpack_public_path__ + "static/media/btn-add-to-slack.02912a19.svg";